import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContentLayout from "../Layout/ContentLayout";
import SchedulePayments from "./views/SchedulePayments";
import { SchedulePaymentDetails } from "./views/SchedulePaymentDetails";
import { schedulePaymentsConstants } from "../../../_redux/_constants";
import { SchedulePaymentsTypeSelect } from "./views/SchedulePaymentsTypeSelect";
import { clearState } from "../../../_redux/_actions";

const SchedulePaymentsWrapper = () => {
  const { activeView } = useSelector((state) => state.schedulePayments);
  const dispatch = useDispatch();

  // clear state when component unmounts
  useEffect(() => {
    return () => {
      dispatch(clearState());
    };
  }, []);

  return (
    <>
      {!activeView ||
      activeView ===
        schedulePaymentsConstants.ACTIVE_VIEW_SELECT_SCHEDULE_PAYMENT_TYPE ? (
        <ContentLayout>
          {!activeView && <SchedulePayments />}

          {activeView ===
            schedulePaymentsConstants.ACTIVE_VIEW_SELECT_SCHEDULE_PAYMENT_TYPE && (
            <SchedulePaymentsTypeSelect />
          )}
        </ContentLayout>
      ) : (
        <SchedulePaymentDetails />
      )}
    </>
  );
};

export default SchedulePaymentsWrapper;
